module.exports = __webpack_public_path__ + "img/product1.06956338.png";